import React from 'react';

import BackgroundImageContainer from '@components/libraryV2/BackgroundImageContainer';
import ExamLinks from '@components/libraryV2/ExamLinks';
import FancyLink from '@components/libraryV2/FancyLink';

import * as styles from './styles.module.scss';

const ExamPicker = () => (
  <div className={styles.layout}>
    <BackgroundImageContainer className={styles.background} theme="emerald" fixed>
      <div className={styles.examsContainer}>
        <div className={styles.exams}>
          <ExamLinks className={styles.exam} withCard />
        </div>

        <FancyLink
          href="https://app.achievable.me/study/achievable/catalog"
          rel="noopener noreferrer"
          target="_blank"
          withArrow
        >
          Explore exam preparation
        </FancyLink>
      </div>
    </BackgroundImageContainer>
  </div>
);

export default ExamPicker;
